import { combineReducers } from "redux";
import { GET_COLLECTION_MODES_LIST_ERROR, GET_COLLECTION_MODES_LIST_START, GET_COLLECTION_MODES_LIST_SUCCESS, GET_COUNTRIES_LIST_ERROR, GET_COUNTRIES_LIST_START, GET_COUNTRIES_LIST_SUCCESS, GET_CUSTOM_CODES_LIST_ERROR, GET_CUSTOM_CODES_LIST_START, GET_CUSTOM_CODES_LIST_SUCCESS, GET_DELIVERY_METHOD_LIST_ERROR, GET_DELIVERY_METHOD_LIST_START, GET_DELIVERY_METHOD_LIST_SUCCESS, GET_DELIVERY_MODE_LIST_ERROR, GET_DELIVERY_MODE_LIST_START, GET_DELIVERY_MODE_LIST_SUCCESS, GET_DELIVERY_TERMS_LIST_ERROR, GET_DELIVERY_TERMS_LIST_START, GET_DELIVERY_TERMS_LIST_SUCCESS, GET_TRANSACTION_A_LIST_ERROR, GET_TRANSACTION_A_LIST_START, GET_TRANSACTION_A_LIST_SUCCESS, GET_TRANSACTION_B_LIST_ERROR, GET_TRANSACTION_B_LIST_START, GET_TRANSACTION_B_LIST_SUCCESS } from "../../../actions/precog/intrastat";

function transactionsCodeA(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case GET_TRANSACTION_A_LIST_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case GET_TRANSACTION_A_LIST_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      list: payload.data
    };
  case GET_TRANSACTION_A_LIST_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function transactionsCodeB(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case GET_TRANSACTION_B_LIST_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case GET_TRANSACTION_B_LIST_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      list: payload.data
    };
  case GET_TRANSACTION_B_LIST_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function deliveryTerms(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case GET_DELIVERY_TERMS_LIST_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case GET_DELIVERY_TERMS_LIST_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      list: payload.data
    };
  case GET_DELIVERY_TERMS_LIST_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function deliveryMode(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case GET_DELIVERY_MODE_LIST_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case GET_DELIVERY_MODE_LIST_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      list: payload.data
    };
  case GET_DELIVERY_MODE_LIST_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function countries(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case GET_COUNTRIES_LIST_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case GET_COUNTRIES_LIST_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      list: payload.data
    };
  case GET_COUNTRIES_LIST_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function deliveryMethod(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case GET_DELIVERY_METHOD_LIST_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case GET_DELIVERY_METHOD_LIST_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      list: payload.data
    };
  case GET_DELIVERY_METHOD_LIST_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function collectionModes(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case GET_COLLECTION_MODES_LIST_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case GET_COLLECTION_MODES_LIST_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      list: payload.data
    };
  case GET_COLLECTION_MODES_LIST_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function customCodes(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case GET_CUSTOM_CODES_LIST_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case GET_CUSTOM_CODES_LIST_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      list: payload.data
    };
  case GET_CUSTOM_CODES_LIST_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

export const intrastatDrawer = combineReducers({
  transactionsCodeA,
  transactionsCodeB,
  deliveryTerms,
  deliveryMode,
  countries,
  deliveryMethod,
  collectionModes,
  customCodes
});

export default intrastatDrawer;
